<template>
  <div>
    <ValidationObserver ref="contactInfo">
      <div class="form-inputs">
        <RsFormInput
          :id="`${id}_first_name`"
          v-model="contactInfo.firstName"
          :label="$ts('companySettings.contactInfo.labelFirstName')"
          name="FirstName"
          type="text"
          :rules="{ required: true, regex: /^[a-zA-Z]*$/ }"
          :debounce="100"
          @input="handleFirstName()"
        />
        <RsFormInput
          :id="`${id}_last_name`"
          v-model="contactInfo.lastName"
          :label="$ts('companySettings.contactInfo.labelLastName')"
          name="LastName"
          type="text"
          :rules="{ required: true, regex: /^[a-zA-Z]*$/ }"
          :debounce="100"
          @input="handleLastName()"
        />
        <RsFormInput
          :id="`${id}_email`"
          v-model="contactInfo.email"
          :label="$ts('companySettings.contactInfo.labelEmail')"
          name="Email"
          type="text"
          :rules="{ required: true, email: true }"
          :debounce="100"
          @input="handleEmail()"
        />
        <RsFormInput
          v-if="requestPhoneNumber"
          :id="`${id}_phone_number`"
          v-model="contactInfo.phoneNumber"
          :label="$ts('companySettings.contactInfo.labelPrimaryPhone')"
          name="PhoneNumber"
          type="text"
          :rules="{ required: true, phone: true }"
          :debounce="100"
          @input="handlePhoneNumber()"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { ValidationObserver } from 'vee-validate';
import { defineComponent } from 'vue';
import { cloneObject } from '@/shared';
import validations from '@/mixins/validation-mixin';

export interface IContactInfo {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
}

export default defineComponent({
  name: 'RsContactInfo',

  mixins: [ validations ],

  props: {
    /**
       * This will be the title of the fields
       */
    id: {
      type: String,
      default: 'contact_info',
    },
    /**
       * This enables/disables phone number form input
       */
    requestPhoneNumber: {
      type: Boolean,
      default: true,
    },
    /**
       * This is the default object for all the contact info
       */
    contactDetails: {
      type: Object as () => IContactInfo,
      default: () => ({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
      } as IContactInfo),
    },

  },
  data() {
    return {
      contactInfo: {} as IContactInfo,
    };
  },

  watch: {
    contactDetails: {
      immediate: true,
      handler() {
        this.contactInfo = cloneObject(this.contactDetails);
      },
    },
  },

  methods: {
    handleFirstName() {
      this.$emit('on-first-name-change', this.contactInfo.firstName);
    },
    handleLastName() {
      this.$emit('on-last-name-change', this.contactInfo.lastName);
    },
    handleEmail() {
      this.$emit('on-email-change', this.contactInfo.email);
    },
    handlePhoneNumber() {
      this.$emit('on-phone-number-change', this.contactInfo.phoneNumber);
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.form-inputs {
    display: flex;
    flex-wrap: wrap;
    gap: 5%;
}
.form-inputs > * {
    width: 25%;
}

</style>
